module.exports = __webpack_public_path__ + "img/KNAB.6f87bf8e.jpg";